import React, { useState } from "react";
import { Card, CardBody, CardText, CardTitle } from "reactstrap";
import hoverOrder from "assets/icon/invOrderHover.svg";
import invOrder from "assets/icon/invOrder.svg";
import invToBeOrder from "assets/icon/invToBeOrder.svg";
import invToBeOrderHover from "../../../assets/icon/invToBeOrderHover.svg";
import invRecieve from "assets/icon/inv-recive-icon.svg";
import invRecieveHover from "assets/icon/item-reciveHover.svg";
import invExpIcon from "assets/icon/inv-exp-icon.svg";
import invExpIconHover from "assets/icon/inv-exp-hover-icon.svg";
import invActive from "assets/icon/inv-active.svg";
import invActiveHover from "assets/icon/inv-active-hover.svg";

const InvDashboard = () => {
  const cardData = [
    {
      id: 1,
      title: "To Be Ordered",
      img: invOrder,
      activeImg: hoverOrder,
      count: "6",
    },
    {
      id: 2,
      title: "On Order",
      img: invToBeOrder,
      activeImg: invToBeOrderHover,
      count: "3",
    },
    {
      id: 3,
      title: "Items to Receive",
      img: invRecieve,
      activeImg: invRecieveHover,
      count: "3",
    },
    {
      id: 4,
      title: "Exceptions",
      img: invExpIcon,
      activeImg: invExpIconHover,
      count: "2",
    },
    {
      id: 5,
      title: "Active Backorders",
      img: invActive,
      activeImg: invActiveHover,
      count: "2",
    },
  ];

  const financialMetrics = [
    {
      title: "Valuation",
      count: "$ 345,345.23",
    },
    {
      title: "Inventory Turn",
      count: "6 Weeks",
    },
    {
      title: "Savings Opportunities",
      count: "12",
    },
    {
      title: "Excess Inventory",
      count: "$10,293",
    },
    {
      title: "Avg. Rx Cost",
      count: "$24.68",
    },
  ];

  const [active, setActive] = useState(null);

  const handleActive = (id) => {
    setActive(id);
  };

  const upcomingDeliveries = [
    {
      id: 12,
      task1: "McKesson #1023850",
      taskContent: "12 Items (2Exceptions)",
    },
    {
      id: 13,
      task1: "Anda #1023851",
      taskContent: "1 Item ",
    },
    {
      id: 14,
      task1: "Cardinal #1023852",
      taskContent: "2 Items",
    },
  ];
  const savingOppertunity = [
    {
      id: 12,
      task1: "Eliquis 5mg Tablets",
      taskContent: "Potential Savings: $7,203.20/year",
    },
    {
      id: 13,
      task1: "Lisinopril 10mg Tablets ",
      taskContent: "Potential Savings: $2,539.39/year",
    },
    {
      id: 14,
      task1: "Ipratropium/Albuterol 0.5-3mg/ml Inh. Sol.",
      taskContent: "Potential Savings: $1,280.71/year",
    },
  ];
  return (
    <div>
      <div className="rounded">
        <h1
          className="p-t-16 p-l-16 pb-16 overview-text"
          style={{ marginBottom: "8px" }}
        >
          Purchasing
        </h1>
        <div
          style={{
            border: "1px solid #D3D3D3",
            marginBottom: "16px",
            marginLeft: "16px",
            marginRight: "16px",
          }}
        ></div>
        <div
          className="d-flex flex-row inv-card-list p-l-16 p-r-16 p-b-16 rounded"
          style={{ gap: "8px" }}
        >
          {cardData.map((card) => (
            <Card
              className="inv-card"
              onClick={() => handleActive(card.id)}
              style={{ border: active === card.id ? "1px solid #702C62" : "" }}
            >
              <div
                className="card-img m-2"
                style={{ backgroundColor: active === card.id ? "#702C62" : "" }}
              >
                <img
                  src={active === card.id ? card.activeImg : card.activeImg}
                  style={{ width: "16px" }}
                />
              </div>
              <CardTitle
                className="inv-text"
                style={{
                  color: active === card.id ? "#702C62" : "",
                }}
              >
                {card.title}
              </CardTitle>
              <CardBody className="inv-count">{card.count}</CardBody>
            </Card>
          ))}
        </div>
        <div style={{ borderBottom: "8px solid #f7f7f7" }}></div>
      </div>
      <div className="d-flex bg-light" style={{ gap: "8px" }}>
        <div
          className="bg-white border-radius-8 p-l-16 p-r-16 "
          style={{ width: "50%", border: "1px solid #D3D3D3" }}
          s
        >
          <div className=" p-t-16">
            <h1 className="heading-text" style={{ marginBottom: "8px" }}>
              Upcoming Deliveries (3)
            </h1>
            <div
              style={{ border: "1px solid #D3D3D3", marginBottom: "16px" }}
            ></div>
          </div>
          {upcomingDeliveries.map((up) => (
            <div key={up.id} className="d-flex justify-content-between p-b-16">
              <div>
                <h4 className="dash-name">{up.task1}</h4>
                <h5 className="min">{up.taskContent} </h5>
              </div>
            </div>
          ))}
        </div>
        <div
          className=" border-radius-8 bg-white"
          style={{ width: "50%", border: "1px solid #D3D3D3" }}
        >
          <div className="p-l-16 p-r-16 p-t-16">
            <h1 className="heading-text" style={{ marginBottom: "8px" }}>
              Top Savings Opportunities (3)
            </h1>
            <div
              style={{ border: "1px solid #D3D3D3", marginBottom: "16px" }}
            ></div>
          </div>
          {savingOppertunity.map((tpp) => (
            <div key={tpp.id} className=" p-l-16 p-r-16 ">
              <div className="p-b-16">
                <h4 className="dash-name">{tpp.task1}</h4>
                <h5 className="min">{tpp.taskContent} </h5>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        className="inv-tasks inv-card-list"
        style={{ borderTop: "8px solid #f7f7f7" }}
      >
        <h1 className="heading-text" style={{ marginBottom: "8px" }}>
          Financial Metrics
        </h1>
        <div
          style={{ border: "1px solid #D3D3D3", marginBottom: "16px" }}
        ></div>
        <div className="d-flex justify-content-start " style={{ gap: "8px" }}>
          {financialMetrics.map((card) => (
            <Card className="inv-finance-card">
              <CardTitle className="finaceMatricsText">{card.title}</CardTitle>
              <CardText className="finance-count">{card.count}</CardText>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvDashboard;
